import { render } from "./LogInForgot.vue?vue&type=template&id=01223843&scoped=true"
import script from "./LogInForgot.vue?vue&type=script&lang=js"
export * from "./LogInForgot.vue?vue&type=script&lang=js"

import "./LogInForgot.vue?vue&type=style&index=0&id=01223843&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01223843"]])

export default __exports__